import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { GroupProvider } from './contexts/GroupContext';
import { CalendarProvider } from './contexts/CalendarContext';
import { GroupAvailabilityProvider } from './contexts/GroupAvailabilityContext';
import { PartyProvider } from './contexts/PartyContext';
import { InvitationProvider } from './contexts/InvitationContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './layouts/AppLayout';

import partyTheme from './theme/partyTheme';
import HomePage from './pages/HomePage';
import SignInPage from './pages/SignInPage';
import DashboardPage from './pages/DashboardPage';
import GroupsPage from './pages/GroupsPage';
import PartiesPage from './pages/PartiesPage';
import ProfilePage from './pages/ProfilePage';
import TestPage from './pages/TestPage';
import DiagnosticPage from './pages/DiagnosticPage';
import ErrorBoundary from './components/ErrorBoundary';
import GroupAnalyticsPage from './pages/GroupAnalyticsPage';
import CalendarPage from './pages/CalendarPage';
import InvitationsPage from './pages/InvitationsPage';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={partyTheme}>
        <CssBaseline />
        <AuthProvider>
          <GroupProvider>
            <CalendarProvider>
              <GroupAvailabilityProvider>
                <PartyProvider>
                  <InvitationProvider>
                    <Router>
                      <div className="App">
                        <Routes>
                          {/* Public routes */}
                          <Route path="/" element={<HomePage />} />
                          <Route path="/signin" element={<SignInPage />} />

                          {/* Test and diagnostic routes */}
                          <Route path="/test" element={<TestPage />} />
                          <Route path="/diagnostics" element={<DiagnosticPage />} />

                          {/* Protected routes with AppLayout */}
                          <Route
                            path="/dashboard"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <DashboardPage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/groups"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <GroupsPage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/groups/analytics"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <GroupAnalyticsPage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />

                          <Route
                            path="/parties"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <PartiesPage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/profile"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <ProfilePage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/calendar"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <CalendarPage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/invitations"
                            element={
                              <ProtectedRoute>
                                <AppLayout>
                                  <InvitationsPage />
                                </AppLayout>
                              </ProtectedRoute>
                            }
                          />
                        </Routes>
                      </div>
                    </Router>
                  </InvitationProvider>
                </PartyProvider>
              </GroupAvailabilityProvider>
            </CalendarProvider>
          </GroupProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
